function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.005 2.575h30.718M3.005 16.91h30.718",
  stroke: "#232A41",
  strokeWidth: 4.096,
  strokeLinecap: "square"
});

var SvgMobileMenuIcon = function SvgMobileMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 19",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAzNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMDA0ODggMi41NzQ3MUgzMy43MjI3IiBzdHJva2U9IiMyMzJBNDEiIHN0cm9rZS13aWR0aD0iNC4wOTU3MSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMy4wMDQ4OCAxNi45MTA2SDMzLjcyMjciIHN0cm9rZT0iIzIzMkE0MSIgc3Ryb2tlLXdpZHRoPSI0LjA5NTcxIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo=";
export { SvgMobileMenuIcon as ReactComponent };